import Newsfeed from "./Newsfeed";

export const routes = [
    {
        path: "/newsfeed",
        component: Newsfeed,
        exact: true,
        showNav: true
    }
]